module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detail"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.information.detail)
    }
  }), _vm._v(" "), _c('dd', {
    staticStyle: {
      "margin-top": "0.5rem",
      "color": "#b3b3b3",
      "font-size": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.information.createtime))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0393cf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Consultation.vue
// module id = 314
// module chunks = 1